/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index tag to autogenerate all the components and extensions
 * Used by "prepareTags"
 */

import Tag from './tag/Tag'
export * from './tag/Tag'
export default Tag
